import React, {useEffect} from "react";
import 
    GetAllRoutines

from '../api/Routines';

import 
    GetAllActivities
    
from '../api/Activities';

const Routines  = (props) => {
    const {routine, setRoutine, activity, setActivity, user } = props 
    
    useEffect( () => {
        GetAllActivities().then(setActivity);
        GetAllRoutines().then(setRoutine);
        
    },[]);
    
       
        
         return ( <>
         
          { routine && routine.map(({ index, id, creatorId, isPublic, name, creatorName, goal, activities}) =>
          
          
          <div key={id} style={{border :  '8px double black',
          width: '380px',
          letterSpacing: '3px'}}>
            
                <div class="card-body" style={{width :  '280px'}}>
                <h5 class="card-title"><b><i><u>Routine By:</u></i></b>&nbsp;&nbsp;{creatorName}</h5>
                <h5 class="card-title">{name}</h5>
                {activities && activities.map((activity, index) => {
                    return <div key={index} style={{width : '300px',
                    border : '10px groove white',
                    borderLeftColor: 'black',
                    borderRightColor: 'black'}}>
                        
                    <div class="card-body">
                    <h5 class="card-title"> <b><i><u>Activity Name:</u></i></b> {activity.name}</h5>
                    <h5 class="card-title"> <b><i><u>Description:</u></i></b> {activity.description}</h5>
                    <h5 class="card-title"> <b><i><u>Count:</u></i></b> {activity.count}</h5>
                    <h5 class="card-title"> <b><i><u>Duration:</u></i></b> {activity.duration}</h5>
                    
                    </div>
                    </div>
                    
                })}
            &nbsp;&nbsp;&nbsp;
          <h6 class="card-subtitle mb-2 text-muted">{goal}</h6>
           
         <p class="card-text">{isPublic === true ? <span>This routine is public.</span> : <span>Private routine</span>}</p>
                
                
                
                </div>
                
               
            </div>
            
            
        
            )}
            
            
            
           
            </>)
    
    

};
export default Routines;